import {
    AfterViewInit,
    Component,
    ElementRef, EventEmitter,
    Input, OnDestroy, Output,
    ViewChild,
    ChangeDetectorRef
} from '@angular/core';

@Component({
    selector: 'script-hack',
    templateUrl: './script-hack.component.html'
})
export class ScriptHackComponent implements AfterViewInit, OnDestroy {
    @Input()
    src: string;

    @Input()
    type: string;

    @Input()
    cdata: boolean;

    @Input()
    noscript: boolean;

    @Input()
    appendToBody: boolean;

    @Output('loaded') loaded: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('script') script: ElementRef;

    public rel: string;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterViewInit() {
        this.rel = (new Date()).getTime() + Math.floor((1 + Math.random()) * 0x100).toString();
        this.cdr.detectChanges();
        this.convertToScript();
    }
    ngOnDestroy() {
        const tag = (this.noscript ? 'noscript' : 'script');
        const element = document.querySelector(`${tag}[rel='${this.rel}']`);

        if (element !== null) {
            element.parentNode.removeChild(element);
        }
    }

    public convertToScript() {
        const element = this.script.nativeElement;
        if (null !== document.querySelector(`script[rel='${this.rel}']`)) {
            const script = document.querySelector(`script[rel='${this.rel}']`);
            script.addEventListener('load', () => this.loaded.emit());

            if (element.innerHTML) {
                script.innerHTML = element.innerHTML;
            }
            if (element.hasAttribute('src')) {
                script.setAttribute('src', element.getAttribute('src'));
            }
        } else {
            const tag = (this.noscript ? 'noscript' : 'script');
            const script = document.createElement(tag);

            script.addEventListener('load', () => this.loaded.emit());
            script.setAttribute('rel', `${+this.rel}`);
            if (!this.noscript) {
                script.setAttribute('type', this.type ? this.type : 'text/javascript');
            }
            if (this.src) {
                script.setAttribute('src', this.src);
            }
            if (element.innerHTML) {
                let html = element.innerHTML;
                if (this.cdata) {
                    html = '/* <![CDATA[ */\n' + html + '\n/* ]]> */';
                }

                script.innerHTML = html;
            }

            const scriptHackTag = element.parentElement;
            if (this.appendToBody) {
                scriptHackTag.setAttribute('rel', this.rel);
                document.body.appendChild(script);
            } else {
                scriptHackTag.parentElement.replaceChild(script, scriptHackTag);
            }
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/components/script-hack/script-hack.component.ts